import { Paper, Typography } from "@mui/material";
import { FAKE_TEXT } from "helpers/constants";

export const Step1 = () => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        How to Provide Feedback
      </Typography>
      <Typography variant="body1" gutterBottom>
        {FAKE_TEXT.LONG2X}
      </Typography>
      <Paper variant="outlined" sx={{ p: 2, my: 2 }}>
        <Typography variant="body1" color="textSecondary">
          Practice using the "Prepare to ADAPT" framework in your clinical
          practice.
        </Typography>
      </Paper>
      <Typography variant="body1">{FAKE_TEXT.LONG2X}</Typography>
    </>
  );
};
